import questionAnswerReducer from './reducers';
export { default as questionAnswerOperations } from './operations';
export { default as questionAnswerTypes} from './types';
export default questionAnswerReducer;
